import { IconButton, Tooltip } from '@mui/material';
import {
  Brightness4 as DarkIcon,
  Brightness7 as LightIcon,
  BrightnessAuto as AutoIcon,
} from '@mui/icons-material';
import { MouseEvent } from 'react';
import { useThemeModeContext } from '@/contexts/ThemeModeContext';

export default function ThemeToggle() {
  const { themeMode, effectiveMode, setThemeMode } = useThemeModeContext();

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    // prevent the parent Menu from closing when toggling
    e.stopPropagation();
    e.preventDefault();

    // cycle: light -> dark -> auto -> light
    const next = themeMode === 'light' ? 'dark' : themeMode === 'dark' ? 'auto' : 'light';
    setThemeMode(next as any);
  };

  // compute next mode (what will be selected when clicking)
  const nextMode = themeMode === 'light' ? 'dark' : themeMode === 'dark' ? 'auto' : 'light';

  const tooltip =
    nextMode === 'auto'
      ? `Cambiar a Auto (${effectiveMode})`
      : `Cambiar a ${nextMode === 'light' ? 'Claro' : 'Oscuro'}`;

  // show the icon for the next mode (the action that will happen)
  const Icon = nextMode === 'auto' ? AutoIcon : nextMode === 'dark' ? DarkIcon : LightIcon;

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={handleClick} size="small" color="inherit" aria-label="alternar tema">
        <Icon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
